export default __webpack_public_path__ + "static/front-cover-arctic-8dc5e8688631cc156a72d253947d9b4b.jpg";